// src/utils/permissions.js

export const ROLES = {
    ADMIN: 'Admin',
    MANAGER: 'Manager',
    AGENT: 'Agent',
};

export const PERMISSIONS = {
    VIEW_DASHBOARD: 'module:dashboard:view',
    VIEW_CUSTOMERS: 'module:customers:view',
    VIEW_TASKS: 'module:tasks:view',
    VIEW_INTERACTIONS: 'module:interactions:view',
    VIEW_REPORTS: 'module:reports:view',
    VIEW_SETTINGS: 'module:settings:view',
    USER_MANAGEMENT_READ: 'user:read',
    USER_MANAGEMENT_CREATE: 'user:create',
    USER_MANAGEMENT_UPDATE: 'user:update',
    USER_MANAGEMENT_DELETE: 'user:delete',
    CUSTOMER_READ: 'customer:read',
    CUSTOMER_CREATE: 'customer:create',
    CUSTOMER_UPDATE: 'customer:update',
    CUSTOMER_DELETE: 'customer:delete',
    CUSTOMER_MERGE: 'customer:merge',
    TASK_READ: 'task:read',
    TASK_CREATE: 'task:create',
    TASK_UPDATE: 'task:update',
    TASK_DELETE: 'task:delete',
    INTERACTION_READ: 'interaction:read',
    INTERACTION_CREATE: 'interaction:create',
    COMMUNICATION_SEND: 'communication:send',
    // Add specific ROLE/LOOKUP permissions if needed, otherwise rely on USER_*
};

// Helper function accepts the dynamic map
export const hasPermission = (roleName, permission, rolesPermissionsMap = {}) => {
    if (!roleName || !permission || !rolesPermissionsMap) {
        // console.warn("hasPermission check failed: Missing role, permission, or map.", { roleName, permission, rolesPermissionsMap });
        return false;
    }
    const permissions = rolesPermissionsMap[roleName] || [];
    const result = permissions.includes(permission);
    // console.log(`Permission Check: Role='${roleName}', Req='${permission}', Has=${result}`); // Uncomment for debugging
    return result;
};